import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Card, Pressable } from '@ui/themed';

export function GridCard(props: {
  icon: IconName;
  title: string;
  body: string;
  isExternal: boolean;
  action?: () => void;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-1 items-stretch justify-center', props.className)}>
      <Pressable
        fullWidth={true}
        fullHeight={true}
        type="card"
        onClick={props.action || (() => {})}
      >
        <Card size="md">
          <Card.Header
            headingLevel="h2"
            icon={props.icon}
            primaryAction={{
              icon: props.isExternal ? 'externalLink' : 'arrowRight',
              variant: 'bare',
            }}
          >
            {props.title}
          </Card.Header>
          <Card.Body>
            {/* For some reason text aligned to the center */}
            <div className="text-start">{props.body}</div>
          </Card.Body>
        </Card>
      </Pressable>
    </div>
  );
}
